<template>
	<div class="pre">
		<div class="pre_right">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/chemicals' }">中国药典</el-breadcrumb-item>
				<el-breadcrumb-item>{{ detail.name }}</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="prer_d2">
				<div class="prer_d2_bac">
					<div class="prer_d2_bac_pad"  v-if="userId == ''">
						<div class="prerd2bac_d1">
							<el-button class="prerd2bac_d1_but" type="success" @click="toLogin" v-if="userId == ''">登录查看完整药方<i class="el-icon-right el-icon--right"></i></el-button>
						</div>
						<div class="prerd2bac_d2"></div>
					</div>
				</div>
				<div v-if="type == 2" :style="userId == '' ? 'max-height:400px;overflow: hidden;'  : ''">
					<h2>{{ detail.name }}</h2>
					<span v-if="detail['分子式'] != null">【分子式】{{ detail["分子式"] }}</span><br v-if="detail['分子式'] != null"/>
					<span v-if="detail['介绍'] != null">【介绍】{{ detail["介绍"] }}</span><br v-if="detail['介绍'] != null"/>
					<span v-if="detail['性状'] != null">【性状】{{ detail["性状"] }}</span><br v-if="detail['性状'] != null"/>
					<span v-if="detail['鉴别'] != null">【鉴别】{{ detail["鉴别"] }}</span><br v-if="detail['鉴别'] != null"/>
					<span v-if="detail['检查'] != null">【检查】{{ detail["检查"] }}</span><br v-if="detail['检查'] != null"/>
					<span v-if="detail['含量测定'] != null">【含量测定】{{ detail["含量测定"] }}</span><br v-if="detail['含量测定'] != null"/>
					<span v-if="detail['类别'] != null">【类别】{{ detail["类别"] }}</span><br v-if="detail['类别'] != null"/>
					<span v-if="detail['规格'] != null">【规格】{{ detail["规格"] }}</span><br v-if="detail['规格'] != null"/>
					<span v-if="detail['贮藏'] != null">【贮藏】{{ detail["贮藏"] }}</span><br v-if="detail['贮藏'] != null"/>
					<span v-if="detail['处方'] != null">【处方】{{ detail["处方"] }}</span><br v-if="detail['处方'] != null"/>
					<span v-if="detail['包装与贮存'] != null">【包装与贮存】{{ detail["包装与贮存"] }}</span><br v-if="detail['包装与贮存'] != null"/>
					<span v-if="detail['标注'] != null">【标注】{{ detail["标注"] }}</span><br v-if="detail['标注'] != null"/>
					<span v-if="detail['活性成分含量'] != null">【活性成分含量】{{ detail["活性成分含量"] }}</span><br v-if="detail['活性成分含量'] != null"/>
					<span v-if="detail['表观放射性活度'] != null">【表观放射性活度】{{ detail["表观放射性活度"] }}</span><br v-if="detail['表观放射性活度'] != null"/>
					<span v-if="detail['放射化学纯度'] != null">【放射化学纯度】{{ detail["放射化学纯度"] }}</span><br v-if="detail['放射化学纯度'] != null"/>
					<span v-if="detail['放射性核纯度'] != null">【放射性核纯度】{{ detail["放射性核纯度"] }}</span><br v-if="detail['放射性核纯度'] != null"/>
					<span v-if="detail['放射性活度'] != null">【放射性活度】{{ detail["放射性活度"] }}</span><br v-if="detail['放射性活度'] != null"/>
					<span v-if="detail['放射性浓度'] != null">【放射性浓度】{{ detail["放射性浓度"] }}</span><br v-if="detail['放射性浓度'] != null"/>
					<span v-if="detail['生产要求'] != null">【生产要求】{{ detail["生产要求"] }}</span><br v-if="detail['生产要求'] != null"/>
					<span v-if="detail['生物分布'] != null">【生物分布】{{ detail["生物分布"] }}</span><br v-if="detail['生物分布'] != null"/>
					<span v-if="detail['效价测定'] != null">【效价测定】{{ detail["效价测定"] }}</span><br v-if="detail['效价测定'] != null"/>
					<span v-if="detail['有关物质'] != null">【有关物质】{{ detail["有关物质"] }}</span><br v-if="detail['有关物质'] != null"/>
					<span v-if="detail['运输'] != null">【运输】{{ detail["运输"] }}</span><br v-if="detail['运输'] != null"/>
					<span v-if="detail['制成'] != null">【制成】{{ detail["制成"] }}</span><br v-if="detail['制成'] != null"/>
					<span v-if="detail['制法'] != null">【制法】{{ detail["制法"] }}</span><br v-if="detail['制法'] != null"/>
					<span v-if="detail['制法要求'] != null">【制法要求】{{ detail["制法要求"] }}</span><br v-if="detail['制法要求'] != null"/>
					<span v-if="detail['制剂'] != null">【制剂】{{ detail["制剂"] }}</span><br v-if="detail['制剂'] != null"/>
					<span v-if="detail['注意'] != null">【注意】{{ detail["注意"] }}</span><br v-if="detail['注意'] != null"/>
					<span v-if="detail['曾用名'] != null">【曾用名】{{ detail["曾用名"] }}</span><br v-if="detail['曾用名'] != null"/>
					<span v-if="detail['附'] != null">【附】{{ detail["附"] }}</span><br v-if="detail['附'] != null"/>
					
				</div>
				
				<div v-else :style="userId == '' ? 'max-height:400px;overflow: hidden;'  : ''">
					<h2>{{ detail.name }}</h2>
					<span v-if="detail['饮片'] != null">【饮片】<span v-html="detail['饮片']"></span></span><br v-if="detail['饮片'] != null"/>
					<span v-if="detail['醇浸出物'] != null">【醇浸出物】{{ detail["醇浸出物"] }}</span><br v-if="detail['醇浸出物'] != null"/>
					<span v-if="detail['附'] != null">【附】{{ detail["附"] }}</span><br v-if="detail['附'] != null"/>
					<span v-if="detail['功能与主治'] != null">【功能与主治】{{ detail["功能与主治"] }}</span><br v-if="detail['功能与主治'] != null"/>
					<span v-if="detail['规定'] != null">【规定】{{ detail["规定"] }}</span><br v-if="detail['规定'] != null"/>
					<span v-if="detail['规格'] != null">【规格】{{ detail["规格"] }}</span><br v-if="detail['规格'] != null"/>
					<span v-if="detail['含量测定'] != null">【含量测定】{{ detail["含量测定"] }}</span><br v-if="detail['含量测定'] != null"/>
					<span v-if="detail['含量则定'] != null">【含量则定】{{ detail["含量则定"] }}</span><br v-if="detail['含量则定'] != null"/>
					<span v-if="detail['挥发性醚浸出物'] != null">【挥发性醚浸出物】{{ detail["挥发性醚浸出物"] }}</span><br v-if="detail['挥发性醚浸出物'] != null"/>
					<span v-if="detail['挥发油'] != null">【挥发油】{{ detail["挥发油"] }}</span><br v-if="detail['挥发油'] != null"/>
					<span v-if="detail['检查'] != null">【检查】{{ detail["检查"] }}</span><br v-if="detail['检查'] != null"/>
					<span v-if="detail['鉴别'] != null">【鉴别】{{ detail["鉴别"] }}</span><br v-if="detail['鉴别'] != null"/>
					<span v-if="detail['浸出物'] != null">【浸出物】{{ detail["浸出物"] }}</span><br v-if="detail['浸出物'] != null"/>
					<span v-if="detail['禁忌'] != null">【禁忌】{{ detail["禁忌"] }}</span><br v-if="detail['禁忌'] != null"/>
					<span v-if="detail['类别'] != null">【类别】{{ detail["类别"] }}</span><br v-if="detail['类别'] != null"/>
					<span v-if="detail['醚溶性浸出物'] != null">【醚溶性浸出物】{{ detail["醚溶性浸出物"] }}</span><br v-if="detail['醚溶性浸出物'] != null"/>
					<span v-if="detail['炮制'] != null">【炮制】{{ detail["炮制"] }}</span><br v-if="detail['炮制'] != null"/>
					<span v-if="detail['适应症'] != null">【适应症】{{ detail["适应症"] }}</span><br v-if="detail['适应症'] != null"/>
					<span v-if="detail['特征图谱'] != null">【特征图谱】{{ detail["特征图谱"] }}</span><br v-if="detail['特征图谱'] != null"/>
					<span v-if="detail['效价测定'] != null">【效价测定】{{ detail["效价测定"] }}</span><br v-if="detail['效价测定'] != null"/>
					<span v-if="detail['性味'] != null">【性味】{{ detail["性味"] }}</span><br v-if="detail['性味'] != null"/>
					<span v-if="detail['性味与归经'] != null">【性味与归经】{{ detail["性味与归经"] }}</span><br v-if="detail['性味与归经'] != null"/>
					<span v-if="detail['性状'] != null">【性状】{{ detail["性状"] }}</span><br v-if="detail['性状'] != null"/>
					<span v-if="detail['乙酸乙酯浸出物'] != null">【乙酸乙酯浸出物】{{ detail["乙酸乙酯浸出物"] }}</span><br v-if="detail['乙酸乙酯浸出物'] != null"/>
					<span v-if="detail['用法与用量'] != null">【用法与用量】{{ detail["用法与用量"] }}</span><br v-if="detail['用法与用量'] != null"/>
					<span v-if="detail['用途'] != null">【用途】{{ detail["用途"] }}</span><br v-if="detail['用途'] != null"/>
					<span v-if="detail['正丁醇浸出物'] != null">【正丁醇浸出物】{{ detail["正丁醇浸出物"] }}</span><br v-if="detail['正丁醇浸出物'] != null"/>
					<span v-if="detail['正丁醇提取物'] != null">【正丁醇提取物】{{ detail["正丁醇提取物"] }}</span><br v-if="detail['正丁醇提取物'] != null"/>
					<span v-if="detail['指纹图谱'] != null">【指纹图谱】{{ detail["指纹图谱"] }}</span><br v-if="detail['指纹图谱'] != null"/>
					<span v-if="detail['制法'] != null">【制法】{{ detail["制法"] }}</span><br v-if="detail['制法'] != null"/>
					<span v-if="detail['制剂'] != null">【制剂】{{ detail["制剂"] }}</span><br v-if="detail['制剂'] != null"/>
					<span v-if="detail['注意'] != null">【注意】{{ detail["注意"] }}</span><br v-if="detail['注意'] != null"/>
					<span v-if="detail['注意事项'] != null">【注意事项】{{ detail["注意事项"] }}</span><br v-if="detail['注意事项'] != null"/>
					<span v-if="detail['贮藏'] != null">【贮藏】{{ detail["贮藏"] }}</span><br v-if="detail['贮藏'] != null"/>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { VUE_APP_IMG_URL } from "@/config"
import { toLogin } from "@/utils"
import { mapGetters } from "vuex"
	export default {
		data() {
			return {
				id:"",
				detail:"",
				rxlist: [],
				imgUrl: "",
				type:1
			}
		},
		computed: {
			 ...mapGetters(["device","userInfo","userId"])
		},
		watch: {

		},
		created: function() {
			this.imgUrl = VUE_APP_IMG_URL
		},
		mounted: function() {
			if(typeof(this.$route.query.id) != "undefined"){
				this.id= this.$route.query.id
				this.type= this.$route.query.type
				if(this.type == 1){
					this.GetBotanicalDrugsInfo()
				}else{
					this.GetBotanicalDrugsInfo()
				}
			}
			this.getRXProductList()
		},
		methods: {
			toDetail() {
				this.$router.push("/prescriptionDetail")
			},
			toLogin(){
				toLogin(this)
			},
			
			getRXProductList() {
				var that = this;
				that.$post('GetRXProductList', {
						"page": 0
					})
					.then(function(res) {
						that.rxlist = res.data.ResultData
						for (var i in that.rxlist) {
							that.rxlist[i].Pic = that.rxlist[i].Pic.split(",")[0]
						}
					})
			},
			buyPrescri(){
				this.$message({
					message: '购买药方需联系平台',
					type: 'success'
				});
			},
			GetBotanicalDrugsInfo(){
				var that = this;
				that.$post('GetBotanicalDrugsInfo', {
						"UserId":that.$store.state.userId,
						"id":that.id
					})
					.then(function(res) {
						that.detail = res.data.ResultData[0]
					})
					console.log(res,'getbot');
			},
			GetChemistryDrugsInfo(){
				var that = this;
				that.$post('GetChemistryDrugsInfo', {
						"UserId":that.$store.state.userId,
						"id":that.id
					})
					.then(function(res) {
						that.detail = res.data.ResultData[0]
					})
			},
			GetJDInfo(){
				var that = this;
				that.$post('GetJDInfo', {
						"UserId":that.$store.state.userId,
						"id":that.id
					})
					.then(function(res) {
						that.detail = res.data.ResultData[0]
					})
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped src="./mobile.scss" ></style>
<style scoped>
.pre {
  width: 100%;
  height: 100%;
  background-image: url("../Home/img/组17.png");
  background-size: cover;
  background-position: center;
}
.pre_right {
  margin: 0 auto;
  padding-top: 15px;
  margin-bottom: 31px;
}
.prer_d2{
	background-color: white;
}
</style>